"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.complexFindModel = exports.toLowerCaseKeys = exports.ComplexData = void 0;
/**
 * Model Lookup module definition
 *
 * Module for finding database models in server/models folder
 */
const decorators_1 = require("@powerednow/shared/modules/utilities/decorators");
const complexData_1 = __importDefault(require("@powerednow/complexData/complexData"));
const allModels_1 = __importDefault(require("./allModels"));
exports.ComplexData = complexData_1.default;
function toLowerCaseKeys(input) {
    const inputEntries = Object.entries(input);
    return inputEntries.reduce((acc, [key, value]) => Object.assign(acc, { [key.toLowerCase()]: value }), {});
}
exports.toLowerCaseKeys = toLowerCaseKeys;
class complexModelLookup {
    /**
     * Finds model by model name
     * @param modelName
     * @returns {*}
     */
    static findModel(modelName) {
        const modelGetter = this._lowerCaseMap[modelName.toLowerCase()];
        if (!modelGetter) {
            throw new Error(`No model found: ${modelName}`);
        }
        const Model = modelGetter();
        if (!Model) {
            throw new Error(`No model found: ${modelName}`);
        }
        // @ts-ignore
        return Model;
    }
}
complexModelLookup.models = {
    ...allModels_1.default,
};
complexModelLookup._lowerCaseMap = toLowerCaseKeys({ ...allModels_1.default }); // ,...mongoModelMap });
exports.default = complexModelLookup;
__decorate([
    decorators_1.bind
], complexModelLookup, "findModel", null);
exports.complexFindModel = complexModelLookup.findModel;
//# sourceMappingURL=../../../src/models/modelLookup.js.map